import * as angular from 'angular';
import { IFormatNumberHelper } from './formatNumberHelper.service';

export interface IrangeCheckHelper {
    isOutOfRange(value: number, min: number, max: number): boolean;
    updateTranslation(min: number, max: number): string;
}

export class RangeCheckHelper implements IrangeCheckHelper {

    static serviceId = 'rangeCheckHelper';
    static $inject = ['$translate', 'formatNumberHelper'];
    private _translated: string;

    constructor($translate: angular.translate.ITranslateService,
        private _fnh: IFormatNumberHelper) {
        this._translated = $translate.instant('Value is out of expected range');
    }

    isOutOfRange(value: number, min: number, max: number): boolean {
        return (!!value || value ===0) && (this.hasBound(min) && value < min) || (this.hasBound(max) && value > max);

    }

    updateTranslation(min: number, max: number): string {
        return `${this._translated} [${this._fnh.format(min)} , ${this._fnh.format(max)}]`;
    }

    private hasBound(val: number) {
        return val || val === 0;
    }

}